import { Box, Button, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import indexApi from '../api';
import IndexTable from '../components/IndexTable';
import { IIndex } from '../interface/IIndex';
import { useToast } from '../helper/ToastProvider';

type Props = {};

const Index = (props: Props) => {
  const [indexes, setIndexes] = useState<Partial<IIndex>[]>();
  const [savedIndexes, setSavedIndexes] = useState<Partial<IIndex>[]>();
  const [edit, setEdit] = useState(false);
  const { showToast } = useToast();

  useEffect(() => {
    getAllIndex();
  }, []);

  const getAllIndex = async () => {
    try {
      const { data } = await indexApi.getAll();
      setIndexes(data);
      setSavedIndexes(JSON.parse(JSON.stringify(data)));
    } catch (e) {
      showToast({ message: 'Index Fetch Failed', severity: 'danger' });
    }
  };

  const save = async () => {
    try {
      await indexApi.updateAll(indexes!);
      getAllIndex();
      showToast({ message: 'Index Save Success', severity: 'success' });
    } catch (e) {
      showToast({ message: 'Index Save Failed', severity: 'danger' });
    }
  };

  return (
    <>
      <Breadcrumb crumb={['Index']} />
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level='h2' component='h1'>
          Index
        </Typography>
        <Box
          sx={{
            display: 'flex',
            mb: 1,
            gap: 1,
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            color='primary'
            onClick={async () => {
              if (edit === true) {
                await save();
              }
              setEdit((prev) => !prev);
            }}
            size='sm'
          >
            {edit ? 'Save' : 'Edit'}
          </Button>
          {edit && (
            <Button
              color='neutral'
              onClick={() => {
                setIndexes(JSON.parse(JSON.stringify(savedIndexes)));
                setEdit((prev) => !prev);
              }}
              size='sm'
            >
              Cancel
            </Button>
          )}
        </Box>
      </Box>
      {indexes && (
        <>
          <IndexTable
            indexes={indexes}
            edit={edit}
            onEdit={(indexId, key, value) => {
              let temp = [...indexes];
              let index = temp.findIndex((obj) => obj.indexId === indexId);
              if (index !== -1) {
                temp[index][key] = value as any;
                setIndexes(temp);
              }
            }}
          />
        </>
      )}
    </>
  );
};

export default Index;
